import React, {useState} from 'react';
import {Row, Col} from 'antd';
import {PlusOutlined} from '@ant-design/icons';

// Components
import TitleComponent from '../../subComponents/TitleComponent';
import ButtonComponent from '../../subComponents/ButtonComponent';
import CarriersTable from './CarriersTable';
import CarriersFormModal from "./CarriersFormModal";

// Types
import {CarrierType} from "../../../types/carrierTypes";


const Carriers = () => {
  const [carrierToEdit, setCarrierToEdit] = useState<CarrierType | undefined>(undefined)
  const [formModalVisible, setFormModalVisible] = useState(false);

  const handleModalVisible = (visible: boolean, carrierToEdit?: CarrierType) => {
    setFormModalVisible(visible);
    setCarrierToEdit(carrierToEdit);
  };

  return (
    <Row>
      <Col md={14} sm={14} xs={24}>
        <TitleComponent level={3}
                        text={'Transportistas'}
                        className={'font-semibold text-gray-900'} />
      </Col>

      <Col md={10} sm={10} xs={24} className={'text-right'}>
        <ButtonComponent text={'Crear transportista'}
                         icon={<PlusOutlined />}
                         className={'w-fit text-white bg-blue-dkt-400 hover:bg-blue-dkt-500 focus:outline-none focus:ring-2 ' +
                           'focus:ring-offset-2 focus:ring-blue-dkt-300 after:content-none'}
                         onClick={() => handleModalVisible(true)}/>
      </Col>

      <Col md={24} xs={24} className={'mt-5 p-6 border border-grey-dkt-300 rounded-lg overflow-hidden bg-white'}>
        <CarriersTable onToggleModal={handleModalVisible} />
      </Col>

      {formModalVisible &&
        <CarriersFormModal isEditing={!!carrierToEdit}
                           carrierToEdit={carrierToEdit}
                           onToggleModal={handleModalVisible} />
      }
    </Row>
  );
}

export default Carriers;